import { StateStatus } from '../interfaces/vehicle.interface';

export enum VehicleStatus {
    PENDING = 'PENDING',
    REGISTERING = 'REGISTERING',
    REGISTERED = 'REGISTERED',
    UNREGISTERING_BY_TOLLING_DEACTIVATED = 'UNREGISTERING_BY_TOLLING_DEACTIVATED',
    UNREGISTERED_BY_TOLLING_DEACTIVATED = 'UNREGISTERED_BY_TOLLING_DEACTIVATED',
    UNREGISTERING_BY_TOLLING_BLOCKED = 'UNREGISTERING_BY_TOLLING_BLOCKED',
    UNREGISTERED_BY_TOLLING_BLOCKED = 'UNREGISTERED_BY_TOLLING_BLOCKED',
    UNREGISTERING_BY_UNCOLLECTIBLE = 'UNREGISTERING_BY_UNCOLLECTIBLE',
    UNREGISTERED_BY_UNCOLLECTIBLE = 'UNREGISTERED_BY_UNCOLLECTIBLE',
    UNREGISTERING_BY_USER = 'UNREGISTERING_BY_USER',
    UNREGISTERING_BY_PAID_UNCOLLECTIBLE = 'UNREGISTERING_BY_PAID_UNCOLLECTIBLE',
    UNREGISTERED_BY_PAID_UNCOLLECTIBLE = 'UNREGISTERED_BY_PAID_UNCOLLECTIBLE',
    UNREGISTERED_BY_USER = 'UNREGISTERED_BY_USER',
    DELETING = 'DELETING',
    DELETED = 'DELETED',
    UPDATING = 'UPDATING',
    REGISTERED_ERROR = 'REGISTERED_ERROR',
    UNREGISTERED_ERROR = 'UNREGISTERED_ERROR',
    REGISTER_FAILED = 'REGISTER_FAILED',
    UPDATE_ERROR = 'UPDATE_ERROR',
    // Estos estados no estan en el backend
    // REGISTER_PENDING = 'REGISTER_PENDING',
    // UNREGISTER_PENDING = 'UNREGISTER_PENDING',
    // VALUE_ACTIVATED = 'VALUE_ACTIVATED',
    // VALUE_DEACTIVATED = 'VALUE_DEACTIVATED',
    // REGISTER_ERROR = 'REGISTER_ERROR',
}

export function getVehicleStatusByCode(status: string): VehicleStatus {
    const vehicleStatus = VehicleStatus[status as keyof typeof VehicleStatus];

    return vehicleStatus;
}

export interface VehicleStatusGroup {
    status: VehicleStatus;
    count: number;
}

export function getVehicleStateStatusGrouped(states: { status: VehicleStatus }[]): StateStatus {
    const stateStatus: StateStatus = {};

    stateStatus.activated = states.filter((state) => state.status === VehicleStatus.REGISTERED).length;
    stateStatus.activated += states.filter((state) => state.status === VehicleStatus.UPDATING).length;

    stateStatus.activating = states.filter((state) => state.status === VehicleStatus.REGISTERING).length;
    // stateStatus.notUpdated = states.filter((state) => isErrorStatus(state.status)).length;

    stateStatus.pending = states.filter((state) => state.status === VehicleStatus.PENDING).length;

    stateStatus.notRegistered = states.filter((state) => state.status === VehicleStatus.REGISTERED_ERROR).length;
    stateStatus.notRegistered += states.filter((state) => state.status === VehicleStatus.UNREGISTERED_ERROR).length;
    stateStatus.notRegistered += states.filter((state) => state.status === VehicleStatus.UPDATE_ERROR).length;
    stateStatus.notRegistered += states.filter((state) => state.status === VehicleStatus.REGISTER_FAILED).length;

    stateStatus.deactivatedBlocked = states.filter((state) => isUnregisteredStatus(state.status) && isBlockedStatus(state.status)).length;
    stateStatus.deactivated = states.filter((state) => isUnregisteredStatus(state.status) && !isBlockedStatus(state.status)).length;
    stateStatus.deactivating = states.filter((state) => isUnregisteringStatus(state.status)).length;
    // stateStatus.notUnregistered = states.filter((state) => isErrorStatus(state.status)).length;

    return stateStatus;
}

export function isUnregisteredStatus(status: VehicleStatus) {
    return (
        status === VehicleStatus.UNREGISTERED_BY_UNCOLLECTIBLE ||
        status === VehicleStatus.UNREGISTERED_BY_PAID_UNCOLLECTIBLE ||
        status === VehicleStatus.UNREGISTERED_BY_TOLLING_BLOCKED ||
        status === VehicleStatus.UNREGISTERED_BY_TOLLING_DEACTIVATED ||
        status === VehicleStatus.UNREGISTERED_BY_USER
    );
}

export function isUnregisteringStatus(status: VehicleStatus) {
    return (
        status === VehicleStatus.UNREGISTERING_BY_TOLLING_BLOCKED ||
        status === VehicleStatus.UNREGISTERING_BY_TOLLING_DEACTIVATED ||
        status === VehicleStatus.UNREGISTERING_BY_USER ||
        status === VehicleStatus.UNREGISTERING_BY_UNCOLLECTIBLE ||
        status === VehicleStatus.UNREGISTERING_BY_PAID_UNCOLLECTIBLE
    );
}

export function isBlockedStatus(status: VehicleStatus) {
    return (
        status === VehicleStatus.UNREGISTERED_BY_TOLLING_BLOCKED ||
        status === VehicleStatus.UNREGISTERING_BY_TOLLING_BLOCKED ||
        status === VehicleStatus.UNREGISTERED_BY_TOLLING_DEACTIVATED ||
        status === VehicleStatus.UNREGISTERING_BY_TOLLING_DEACTIVATED ||
        status === VehicleStatus.UNREGISTERED_BY_UNCOLLECTIBLE ||
        status === VehicleStatus.UNREGISTERING_BY_UNCOLLECTIBLE ||
        status === VehicleStatus.UNREGISTERING_BY_PAID_UNCOLLECTIBLE
    );
}

export function isErrorStatus(status: VehicleStatus) {
    return (
        status === VehicleStatus.UNREGISTERED_ERROR || status === VehicleStatus.REGISTERED_ERROR || status === VehicleStatus.UPDATE_ERROR
    );
}
